var render, staticRenderFns
import script from "./TabPerformanceMixin.vue?vue&type=script&lang=ts&"
export * from "./TabPerformanceMixin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports